module.exports = __webpack_public_path__ + "img/photo-3-1.dc8d3884.webp";